const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        $( ".menu-item-has-children" ).append( "<span class='ico ico-plus'>+</span><span class='ico ico-minus'>-</span>" );
        $('.menu-toggle').on('click', function() {
            $('.sub-menu').slideUp();
            $('.header-overlay').toggleClass('active');
            $('.menu-header-menu-container').toggleClass('active');
            $(this).toggleClass('active');
        });
        $( ".ico-plus" ).on('click', function() {
            $( ".menu-item-has-children" ).removeClass( "open" );
            $('.sub-menu').slideUp();
            $( this ).parent().addClass( "open" ).find( ".sub-menu" ).slideDown();
        });
        $( ".ico-minus" ).on('click', function() {
            $( ".menu-item-has-children" ).removeClass( "open" );
            $('.sub-menu').slideUp();
        });

        $('.header-overlay').on('click', function(e) {
            if (e.target !== this)
                {return;}
            
            $('.sub-menu').slideUp();
            $('.header-overlay').toggleClass('active');
            $('.menu-header-menu-container').toggleClass('active');
            $('.menu-toggle').toggleClass('active');
            
        });
    }

}

export default _this;